/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-controller-access-in-routes, ember/no-get, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { alias } from '@ember/object/computed';
import { next } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class AnalysisRoute extends Route {
  queryParams = {
    dateFrom: {
      refreshModel: false,
      as: 'from',
    },
    dateTo: {
      refreshModel: false,
      as: 'to',
    },
    year: {
      refreshModel: false,
      as: 'year',
    },
    term: {
      refreshModel: false,
      as: 'term',
    },
    groupId: {
      refreshModel: true,
    },
  };

  // Attrs
  @alias('session.school.jurisdiction')
  jurisdiction;

  // Services
  @service
  schoolSchema;

  @service
  session;

  @service
  store;

  @service
  terms;

  async beforeModel() {
    super.beforeModel(...arguments);
    // Prevents an error when loading the route before visiting any others
    await this.terms.waitUntilLoaded();
  }

  model(params) {
    let year = isEmpty(params.year) ? moment().year() : params.year;
    let term = this.get('terms.currentTerm');
    let dateFrom = isEmpty(params.dateFrom) ? term.start : params.dateFrom;
    let dateTo = isEmpty(params.dateTo) ? term.end : params.dateTo;
    let groupId = params.groupId;

    let data = {
      analyses: this.store.query('attendance/analysis', {
        dateFrom,
        dateTo,
        groupId,
      }),
      terms: this.store
        .findAll('term')
        .then((terms) =>
          terms
            .filter((t) => t.year === parseInt(year, 10))
            .sort((a, b) => a.term - b.term),
        ),
      groups: this.store.query('group', { year }),
      genderField: this.schoolSchema.getLearnerGenderField(),
    };

    if (this.jurisdiction !== Jurisdiction.NZ_MOE) {
      data.movementCodes = this.store.query('attendance/movement-code', {
        dateFrom,
        dateTo,
        groupId,
      });
      data.dayCodeAnalyses = this.store.query('attendance/day-code', {
        dateFrom,
        dateTo,
        analysis: true,
      });
    }

    return hash(data);
  }

  setupController(controller) {
    super.setupController(...arguments);
    let term = this.get('terms.currentTerm');
    // Preset controller date fields
    if (isEmpty(this.controller.dateFrom)) {
      controller.set('dateFrom', term.start);
    }
    if (isEmpty(this.controller.dateTo)) {
      controller.set('dateTo', term.end);
    }
    // Don't use isEmpty check here as we only
    // want to preset the termId on initial load
    // (controller initially sets termId to null
    // when dates are changed it's converted to an empty string)
    if (this.controller.termId === null) {
      controller.set('termId', term.id);
    }
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controller.reset();
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }

  resetController() {
    // Unload all day codes from the store
    this.store.unloadAll('attendance/day-code');
  }
}
